"use client";

import React, { Suspense, useState } from "react";
import { Form, Formik } from "formik";
import { Picture } from "@/app/components/form/picture";
import { FormButton } from "@/app/components/form/form-button";
import { notify } from "@/app/components/toast";
import Input from "@/app/components/form/input";
import data from "@/data/data.json";

import { ForgotPassword } from "@/actions/auth";
import { ForgotPasswordSchema } from "@/schema/auth";

const ForgotPasswordComponent = () => {
  const [sent, setSent] = useState(false);

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const fd = new FormData();
      Object.entries(values).forEach(([k, v]) => fd.append(k, v ?? ""));
      const res = await ForgotPassword(fd);

      if (res?.meta?.code === 200) {
        setSent(true);
      } else {
        notify(res);
      }
    } finally {
      setSubmitting(false);
    }
  };

  const appName = process.env.NEXT_PUBLIC_APP_NAME;
  const logoPath = appName ? `/img/${data[appName]?.logo}` : "/img/logo.png";

  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{
        height: "100vh",
        width: "100vw",
        background: `url('/img/bg.avif') no-repeat`,
        backgroundSize: "cover",
      }}
    >
      <div className="card" style={{ width: "30rem", paddingTop: "2rem" }}>
        <Picture
          path={logoPath}
          height={75}
          alt="logo"
          style={{ paddingTop: "2rem" }}
        />
        <center className="py-2">
          <h3>Forgot Password</h3>
        </center>
        <div className="card-body">
          {sent ? (
            <>
              <p>
                <b>
                  If your account is registered with us, you will receive a
                  password reset link!
                </b>
              </p>
              <p>
                Please check your inbox. If you don’t see it, kindly check your
                spam or junk folder as well.
              </p>
            </>
          ) : (
            <>
              <p>
                Please provide your email address to receive password reset
                instructions.
              </p>
              <Formik
                initialValues={{ email: "" }}
                validationSchema={ForgotPasswordSchema}
                onSubmit={handleSubmit}
              >
                {() => (
                  <Form noValidate>
                    <Input
                      name="email"
                      label="Email address"
                      col={12}
                      required
                    />
                    <div className="py-3 text-start">
                      <FormButton label="Reset Password" className="w-50" />
                    </div>
                  </Form>
                )}
              </Formik>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default function Page() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <ForgotPasswordComponent />
    </Suspense>
  );
}
